import { Component, OnDestroy, OnInit, ElementRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { environment } from '@environments/environment';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { BookingService } from '@ibe/services';
import { ModalService, BrowserService } from '@ibe/services/ui';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { Store } from '@ngrx/store';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import { INDRAStopoverService } from '@ibe.services/stopover.indra.service';
import { INDRABFMStopoverRequestParam, INDRABFMStopoverResponse } from '@ibe.models/stopover.indra.model';
import {
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	TRIP_TYPE_MULTICITY,
	TRIP_TYPE_ONE_WAY,
	TRIP_TYPE_ROUND_TRIP,
	TRIP_TYPE_MULTICITY_DESCRIPTION,
	TRIP_TYPE_ONE_WAY_CODE
} from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

const moment = extendMoment(Moment);

@Component({
	selector: 'app-stopover-modal',
	templateUrl: './stopover-modal.indra.component.html',
	styleUrls: ['./stopover-modal.component.scss'],
	host: { class: 'app-stopover-modal' },
})
export class INDRAStopoverModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {
	hasSelectedRoute: boolean = true;
	isEligibleRoute: boolean = true;
	isLoading = true;
	isAlive = true;

	labels = { departure: 'Departure', arrival: 'Arrival' };

	stopovers$: Observable<any> = this.store.select(fromStore.getMiniIBEStopovers);
	stopovers = new BehaviorSubject([]);

	availableStopover = {
		portugal: false,
		brasil: false
	};

	selectedStopover = {
		portugal: false,
		brasil: false
	};


	searchRoutes$: Observable<any> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoutes = [];

	routeType$: Observable<any> = this.store.select(fromStore.getMiniIBERouteType);
	route_type;

	hasChanges$: Observable<any> = combineLatest(this.searchRoutes$, this.stopovers$, this.routeType$);
	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	form: FormGroup;

	disableSince: any = '';
	disableUntil: any = '';
	markDates: any = '';

	triedToSubmit = false;
	showAnimation: boolean = false;

	private animationPortugal: any;
	private animationBrasil: any;
	private animationBackground: any;

	public lottieConfigPortugal: Object;
	public lottieConfigBrasil: Object;
	public lottieConfigBackground: Object;

	stopoverSearchRoute = [];
	tripType: string;

	nights: any = [
		{
			label: 1,
			value: 1
		},
		{
			label: 2,
			value: 2
		},
		{
			label: 3,
			value: 3
		},
		{
			label: 4,
			value: 4
		},
		{
			label: 5,
			value: 5
		}
	];

	airportList: any;

	oneWay = TRIP_TYPE_ONE_WAY;

	storedStopover;

	enable10DaysStopover: boolean;
	setIncrementToDisable: string = '';
	stopoverDaysMin: number = 1;
	resetDayCounterFlag: boolean = false;

	constructor(
		private fb: FormBuilder,
		protected bookingService: BookingService,
		private store: Store<fromStore.State>,
		protected modalService: ModalService,
		private browserService: BrowserService,
		private stopoverService: INDRAStopoverService,
		private elementRef: ElementRef,
		protected ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
	) {
		super(modalService);
		this.enable10DaysStopover = this.ibeAdminConfigService.getConfigurationValue('bookingSearch.enable10DaysStopover') === 'true' ? true : false;

		this.form = this.fb.group({
			searchroute: this.fb.array([]),
			stopover: this.fb.array([])
		});
		moment.locale(environment.locale);

		this.form.valueChanges.subscribe(value => {
			this.triedToSubmit = false;
		});

		this.lottieConfigPortugal = {
			path: './assets/animations/stopover-portugal.json',
			renderer: 'svg',
			autoplay: true,
			loop: true
		};
		this.lottieConfigBrasil = {
			path: './assets/animations/stopover-brasil.json',
			renderer: 'svg',
			autoplay: true,
			loop: true
		};
		this.lottieConfigBackground = {
			path: './assets/animations/stopover-background.json',
			renderer: 'svg',
			autoplay: true,
			loop: true
		};

		this.bookAwardFlights$.subscribe(value => {
			this.bookAwardFlights = value;
			this.isEligibleRoute = !this.bookAwardFlights;
		});
	}

	ngOnInit() {
		if (this.data) {
			this.airportList = this.data;
		}

		this.showAnimation = !this.browserService.isDeprecatedBrowser();

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([searchRoutes, stopovers, routeType]) => {
				if (stopovers) {
					this.storedStopover = stopovers;
				}
				if (searchRoutes) {
					if (searchRoutes[0].departure && searchRoutes[0].arrival) {
						let newSearchRoutes = Object.assign([], searchRoutes).splice(0, 1);

						newSearchRoutes = newSearchRoutes.filter(cur => cur.arrival && cur.departure);
						this.searchRoutes = newSearchRoutes;

						this.labels.departure = `${newSearchRoutes[0].departure.code} - ${newSearchRoutes[0].arrival.code}`;
						this.labels.arrival = `${newSearchRoutes[0].arrival.code} - ${newSearchRoutes[0].departure.code}`;

						const countries = newSearchRoutes.map(cur => ({ departure: cur.departure.code, arrival: cur.arrival.code }));
						if (!countries.length) {
							this.hasSelectedRoute = false;
							// this.isEligibleRoute = true;
							setTimeout(() => { this.isLoading = false; }, 1500);
						} else {
							this.tripType = routeType;
							this.stopoverSearchRoute =
								(this.tripType == TRIP_TYPE_MULTICITY) ? searchRoutes : this.searchRoutes;

							this.INDRA_getStopovers();
						}
					} else {
						this.isLoading = false;
						this.hasSelectedRoute = false;
					}
				}

			});


		this.disableUntil = { year: moment().format('YYYY'), month: moment().format('M'), day: moment().subtract(1, 'days').format('D') };
		// this.disableSince = { year: moment().year(), month: moment().month(), day: moment().day() };

		this.form.valueChanges.subscribe(value => {
			this.triedToSubmit = false;
		});

		if (this.enable10DaysStopover) {
			this.nights.push(
				{
					label: 6,
					value: 6
				},
				{
					label: 7,
					value: 7
				},
				{
					label: 8,
					value: 8
				},
				{
					label: 9,
					value: 9
				},
				{
					label: 10,
					value: 10
				}
			);
		}
	}

	INDRA_showError(control) {
		const condition = this.triedToSubmit && !control.valid;
		return condition;
	}

	ngOnDestroy() {
		this.isAlive = false;

		if (this.animationPortugal) {
			this.animationPortugal.destroy();
		}
		if (this.animationBrasil) {
			this.animationBrasil.destroy();
		}
		if (this.animationBackground) {
			this.animationBackground.destroy();
		}
	}

	INDRA_departureDatepickerOptions(arrivalControl) {
		if (!arrivalControl) {
			return;
		}

		const dateArrival = arrivalControl.value;
		const until = moment().subtract(1, 'days');
		const disableUntil = { year: until.format('YYYY'), month: until.format('M'), day: until.format('D') };

		const since = moment().add(360, 'days');
		let disableSince = { year: since.format('YYYY'), month: since.format('M'), day: since.format('D') };

		if (dateArrival) {
			const arrival = moment(dateArrival, 'DD/MM/YYYY');
			disableSince = { year: arrival.format('YYYY'), month: arrival.format('M'), day: arrival.format('D') };
		}


		const result = { disableUntil, disableSince };

		return result;
	}

	INDRA_arrivalDatepickerOptions(dateDeparture) {
		const since = moment().add(360, 'days');
		const disableSince = { year: since.format('YYYY'), month: since.format('M'), day: since.format('D') };
		const result = { disableSince };

		if (dateDeparture) {
			const departure = moment(dateDeparture, 'DD/MM/YYYY');
			const disableUntil = { year: departure.format('YYYY'), month: departure.format('M'), day: departure.format('D') };
			result['disableUntil'] = disableUntil;
		}
		return result;
	}

	/**
	 * Create form controls with initial values and restrictions
	 */
	private createForm(stopovers) {
		const searchRoutes = this.stopoverSearchRoute.map(stopover => {
			if (this.tripType == TRIP_TYPE_ONE_WAY) {
				return this.fb.group({
					departure: [
						stopover.departure && stopover.departure.date ?
							moment(stopover.departure.date).format('DD/MM/YYYY') :
							null,
						Validators.required]
				});
			} else if (this.tripType == TRIP_TYPE_MULTICITY) {
				return this.fb.group({
					departure: [
						stopover.date ?
							moment(stopover.date).format('DD/MM/YYYY') :
							null,
						Validators.required]
				});
			} else {
				return this.fb.group({
					departure: [
						stopover.departure && stopover.departure.date ?
							moment(stopover.departure.date).format('DD/MM/YYYY') :
							null,
						Validators.required],
					arrival: [
						stopover.arrival && stopover.arrival.date ?
							moment(stopover.arrival.date).format('DD/MM/YYYY') :
							null,
						Validators.required],
				});
			}
		});

		this.form = this.fb.group({
			searchroute: this.fb.array(searchRoutes),
			stopover: this.fb.array(
				stopovers.map(stopover => {
					return this.fb.group({
						active: [this.enable10DaysStopover ? true : false],
						country: [stopover.country],
						city: ['', Validators.required],
						when: [this.enable10DaysStopover && this.tripType === TRIP_TYPE_ONE_WAY ? 'outbound' : ''],
						days: [this.enable10DaysStopover && this.tripType === TRIP_TYPE_MULTICITY ? 1 : ''],
						id: [stopover.id],
					});
				})
			),
		});

		/*	display stopover from store
		*	upon load if a stopover was
		*	previously selected
		*/
		if (this.storedStopover.length > 0) {

			if (this.tripType === TRIP_TYPE_ROUND_TRIP || this.tripType === TRIP_TYPE_MULTICITY) {
				// set values to form for one or more stopovers
				this.storedStopover.forEach((stopover, i) => {
					let activeIndex;
					if ((this.form.get('stopover') as FormArray).at(i).get('country').value === stopover.country) {
						activeIndex = i;
					} else if ((this.form.get('stopover') as FormArray).at(i + 1).get('country').value === stopover.country) {
						activeIndex = i + 1;
					}

					(this.form.get('stopover') as FormArray).at(activeIndex).get('active').setValue(true);
					(this.form.get('stopover') as FormArray).at(activeIndex).get('days').setValue(stopover.days);
					(this.form.get('stopover') as FormArray).at(activeIndex).get('when').setValue(stopover.when);

					const result = this.stopovers.value[activeIndex].city.find(cur => cur.id == stopover.city.code) || null;
					(this.form.get('stopover') as FormArray).at(activeIndex).get('city').setValue(result);
				});
			} else {
				const storedCountry = this.storedStopover[0].country;
				// look for form index based on active country of stored stopover
				const index = this.form.get('stopover').value.findIndex(el => el.country == storedCountry);

				// checks country checkbox from stored stopover
				(this.form.get('stopover') as FormArray).at(index).get('active').setValue(true);

				// set days from stored stopover
				(this.form.get('stopover') as FormArray).at(index).get('days').setValue(this.storedStopover[0].days);

				// set city from stored stopover
				// (this.form.get('stopover') as FormArray).at(0).get('city').setValue(this.storedStopover.city);
				const result = this.stopovers.value[index].city.find(cur => cur.id == this.storedStopover[0].city.code) || null;
				(this.form.get('stopover') as FormArray).at(index).get('city').setValue(result);

				// set when from stored stopover
				(this.form.get('stopover') as FormArray).at(index).get('when').setValue(this.storedStopover[0].when);
			}
		}

		/* if (dataFilled) {
			for (const stopover of dataFilled) {
				let indexStopover;

				if (this.tripType == ) {
					indexStopover = this.form.get('stopover').value.findIndex((el) => el.id == stopover.id);
				} else {
					indexStopover = this.form.get('stopover').value.findIndex((el) => el.country == stopover.country);
				}

				(this.form.get('stopover') as FormArray).at(indexStopover).setValue(stopover);
				(this.form.get('stopover') as FormArray).at(indexStopover).get('active').setValue(true);

			}
		} */

		const OnlyWhen = (AC: AbstractControl) => {
			const stops = (AC.get('stopover') as FormArray);
			const actives = stops.value.filter(cur => cur.active);

			if (stops.length > 1 /* && this.tripType != TRIP_TYPE_MULTICITY */) {

				const duplicatesWhen = stops.value
					.filter(cur => cur.when)
					.map(cur => cur.when)
					.sort()
					.filter((cur, idx, arr) => cur == arr[idx + 1]);


				if (duplicatesWhen.length && actives.length > 1) stops.setErrors({ DuplicatesWhen: true });
				if (stops.length && !actives.length) stops.setErrors({ notSelected: true });

			} else if (stops.length && !actives.length) {
				stops.setErrors({ notSelected: true });
			} else {
				stops.setErrors(null);
				stops.clearValidators();
			}

			return null;
		};

		this.form.setValidators(OnlyWhen);
	}

	INDRA_stopoverDisable() {
		return this.form.get('stopover').value.map(cur => ({ value: cur.when }));
	}

	INDRA_getLabel(item, type = 'departure', idx = 0) {

		let label, infoSearchRoute;

		if (this.tripType == TRIP_TYPE_MULTICITY) {

			infoSearchRoute = this.searchRoutes[idx];

		} else {
			infoSearchRoute = this.searchRoutes.find(v => v.arrival.code == item.arrival.code && v.departure.code == item.departure.code);
			if (!infoSearchRoute) infoSearchRoute = item;
		}

		if (type == 'departure')
			label = `${infoSearchRoute.departure.location.city} - ${infoSearchRoute.arrival.location.city}`;

		if (type == 'arrival')
			label = `${infoSearchRoute.arrival.location.city} - ${infoSearchRoute.departure.location.city}`;

		return label;
	}

	INDRA_getPlaceholder(item, type = 'departure', idx = 0) {

		let label, infoSearchRoute;

		if (this.tripType == TRIP_TYPE_MULTICITY) {

			infoSearchRoute = this.searchRoutes[idx];

		} else {
			infoSearchRoute = this.searchRoutes.find(v => v.arrival.code == item.arrival.code && v.departure.code == item.departure.code);
			if (!infoSearchRoute) infoSearchRoute = item;
		}

		if (type == 'departure')
			label = `From ${infoSearchRoute.departure.location.city} - ${infoSearchRoute.arrival.location.city}?`;

		if (type == 'arrival')
			label = `To ${infoSearchRoute.arrival.location.city} - ${infoSearchRoute.departure.location.city}?`;

		return label;
	}

	INDRA_getCityLabel(type = 'departure') {
		let label;

		if (type == 'departure') label = this.searchRoutes[0].departure.location.city;
		if (type == 'arrival') label = this.searchRoutes[0].arrival.location.city;

		return label;
	}

	INDRA_getCountryLabel() {
		if ((!this.hasSelectedRoute || !this.isEligibleRoute)) {
			return this.INDRA_getTranslationKey('modals.text.countryLabel');
		} else if (!this.selectedStopover.portugal && !this.selectedStopover.brasil) {
			if (this.availableStopover.portugal && this.availableStopover.brasil) {
				return this.INDRA_getTranslationKey('modals.text.portugalBrazil');
			} else if (this.availableStopover.portugal) {
				return this.INDRA_getTranslationKey('modals.text.portugal');
			} else if (this.availableStopover.brasil) {
				return this.INDRA_getTranslationKey('modals.text.brazil');
			}
		} else {
			if (this.selectedStopover.portugal && this.selectedStopover.brasil) {
				return this.INDRA_getTranslationKey('modals.text.countryLabel');
			} else if (this.selectedStopover.portugal) {
				return this.INDRA_getTranslationKey('modals.text.portugal');
			} else if (this.selectedStopover.brasil) {
				return this.INDRA_getTranslationKey('modals.text.brazil');
			}
		}
	}

	INDRA_close() {
		this.closeModal();
	}

	INDRA_changeInput(event, form) {
		form.setValue(event);
	}

	compareFn(c1, c2): boolean {
		return c1 && c2 ? c1.id === c2.id : c1 === c2;
	}

	INDRA_handleClose(event) {
		event.preventDefault();
		this.triedToSubmit = true;
		if (this.form.valid) {
			// if one country is unchecked clear its values
			const activeStops = (this.form.get('stopover') as FormArray).value.filter(cur => cur.active);
			if (activeStops.length < 2 && (this.form.get('stopover') as FormArray).length > 1) {
				const index = this.form.get('stopover').value.findIndex(el => el.active == false);
				(this.form.get('stopover') as FormArray).at(index).get('when').setValue('');
				(this.form.get('stopover') as FormArray).at(index).get('city').setValue('');
				(this.form.get('stopover') as FormArray).at(index).get('days').setValue('');
			}

			this.isLoading = true;
			const formValues = this.form.value;
			const stopover = formValues.stopover.filter(cur => cur.active);
			for (const i in stopover) {
				const selectedStopoverDetails = this.INDRA_getAirportByCode(stopover[i].city.code);
				stopover[i].city = selectedStopoverDetails;
			}

			// searchRoutes needs only first index for RT/OW single flight row
			// stopoverSearchRoute needs two index for multicity flight rows
			const newSearchRoutes = this.searchRoutes.map((cur, idx) => {
				const c = { departure: Object.assign({}, cur.departure), arrival: Object.assign({}, cur.arrival), date: cur.date, id: cur.id };
				if (this.tripType !== TRIP_TYPE_MULTICITY) {
					c.departure.date = moment(formValues.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
					c.arrival.date = moment(formValues.searchroute[idx].arrival, 'DD/MM/YYYY').toDate();
				}

				return c;
			});

			const multicitySearchRoutes = this.stopoverSearchRoute.map((cur, idx) => {
				const c = { departure: Object.assign({}, cur.departure), arrival: Object.assign({}, cur.arrival), date: cur.date, id: cur.id };
				c.date = moment(formValues.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
				c.departure.date = moment(formValues.searchroute[idx].departure, 'DD/MM/YYYY').toDate();

				return c;
			});

			this.isAlive = false;
			this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
			if (this.tripType === TRIP_TYPE_MULTICITY) {
				this.store.dispatch(new MiniIBEActions.PutSearchRoute(multicitySearchRoutes));
			} else {
				this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
			}
			this.store.dispatch(new MiniIBEActions.PutStovers(stopover));
			this.INDRA_close();
		} else {
			const invalidControl = this.elementRef.nativeElement.querySelector('.form-field .ng-invalid');

			if (invalidControl) {
				invalidControl.scrollIntoView();
				invalidControl.focus();
			}
		}
	}

	INDRA_showConfirmButton() {
		return true; // TODO
	}

	INDRA_handleCountry(stopover: FormGroup) {
		this.changeAnimation(this.form.get('stopover') as FormArray);
		stopover.value.active = true;
		if (stopover.value.active) {
			this.INDRA_setRequiredValidators(stopover);

			if (this.tripType === TRIP_TYPE_ONE_WAY) {
				// one stop over only in OW
				for (const stopoverArr of (this.form.get('stopover') as FormArray).controls) {
					stopoverArr.get('active').setValue(false);

					this.INDRA_clearValidators(stopoverArr as FormGroup);
				}

				stopover.get('when').setValue('outbound');
			}
			stopover.get('active').setValue(true);

			this.INDRA_setRequiredValidators(stopover);

		} else {
			this.INDRA_clearValidators(stopover);


		}

	}

	changeAnimation(stops: FormArray) {
		for (const stop of stops.controls) {
			stop.get('active').valueChanges.pipe(takeWhile(() => this.isAlive))
				.subscribe(data => {
					if (stop.get('active').value == true) {
						if (stop.get('country').value == 'Brazil') {
							this.selectedStopover.brasil = stop.get('active').value;
						} else {
							this.selectedStopover.portugal = stop.get('active').value;
						}
					} else {
						if (stop.get('country').value == 'Brazil') {
							this.selectedStopover.brasil = stop.get('active').value;
						} else {
							this.selectedStopover.portugal = stop.get('active').value;
						}
					}
				});
		}
	}

	INDRA_setRequiredValidators(form: FormGroup) {
		for (const key in form.controls) {
			form.get(key).setValidators(Validators.required);
			form.get(key).updateValueAndValidity();
		}
	}

	INDRA_clearValidators(form: FormGroup) {
		for (const key in form.controls) {
			form.get(key).clearValidators();
			form.get(key).updateValueAndValidity();
		}
	}

	INDRA_getStopovers() {

		let validSearchRoute = [];
		// note: searchRoute for round trip is 2 (outbound and inbound), so only use the outbound
		if (this.tripType === TRIP_TYPE_ROUND_TRIP) {
			validSearchRoute.push(this.stopoverSearchRoute[0]);
		} else {
			validSearchRoute = this.stopoverSearchRoute;
		}

		const language = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) : DEFAULT_LANGUAGE;

		// create request for all search routes
		const stopoverRequests = validSearchRoute.map(route => {
			return new Promise((resolve, reject) => {
				const arrival = route.arrival.code;
				const departure = route.departure.code;

				const params: INDRABFMStopoverRequestParam = {
					destination: arrival,
					language: language,
					origin: departure,
					tripType: this.tripType,
				};

				this.stopoverService.getStopover(params).subscribe((response: INDRABFMStopoverResponse) => {
					if (response && response.countries && response.countries.length > 0) {
						const routeStopoverResponse = { [`${departure}-${arrival}`]: response.countries };
						resolve(routeStopoverResponse);

						response.countries.forEach(res => {
							if (res.country == 'Brazil') {
								this.availableStopover.brasil = true;
							} else if (res.country == 'Portugal') {
								this.availableStopover.portugal = true;
							}
						});
					} else {
						// this.isEligibleRoute = false;
						resolve(null);
					}
				}, error => {
					// this.isEligibleRoute = false;
					reject(error);
				});
			});
		});

		const stopoverResponse = [];

		// execute when promises completes
		Promise.all(stopoverRequests).then(response => {
			response.forEach(res => {
				if (res) {
					stopoverResponse.push(res);
				} else {
					stopoverResponse.push({});
				}
			});

			// NOTE: this country list should be with complete with its cities regardless
			// of which api response the city was originally from
			const uniqueStopovers = this.createUniqueStopoverList(stopoverResponse);
			if (uniqueStopovers && uniqueStopovers.length > 0) {
				if (this.tripType == TRIP_TYPE_ONE_WAY) {
					this.stopovers.next(uniqueStopovers.map(cur => {
						const arrival = this.stopoverSearchRoute[0].arrival.location.cityName;
						const departure = this.stopoverSearchRoute[0].departure.location.cityName;

						cur.options_city = cur.airports.map(airports => ({
							label: airports.airportTranslated,
							value: airports.codAirport
						}));
						cur.city = cur.airports.map(airports => ({
							id: airports.codAirport,
							code: airports.codAirport
						}));
						cur.id = `${arrival}-${departure}`;
						cur.when = [
							{
								'label': `${this.stopoverSearchRoute[0].departure.location.city} - ${this.stopoverSearchRoute[0].arrival.location.city}`,
								'value': 'outbound'
							}
						];
						return cur;
					}));
				} else if (this.tripType == TRIP_TYPE_ROUND_TRIP) {
					this.stopovers.next(uniqueStopovers.map(cur => {
						const arrival = this.stopoverSearchRoute[0].arrival.location.cityName;
						const departure = this.stopoverSearchRoute[0].departure.location.cityName;

						cur.options_city = cur.airports.map(airports => ({
							label: airports.airportTranslated,
							value: airports.codAirport
						}));
						cur.city = cur.airports.map(airports => ({
							id: airports.codAirport,
							code: airports.codAirport
						}));
						cur.id = `${arrival}-${departure}`;
						cur.when = [
							{
								'label': `${this.stopoverSearchRoute[0].departure.location.city} - ${this.stopoverSearchRoute[0].arrival.location.city}`,
								'value': 'outbound'
							},
							{
								'label': `${this.stopoverSearchRoute[0].arrival.location.city} - ${this.stopoverSearchRoute[0].departure.location.city}`,
								'value': 'inbound'
							}
						];
						return cur;
					}));
				} else { // multicity

					// construct initial stopovers array
					const stopoversList = uniqueStopovers.map((cur) => {
						cur.options_city = cur.airports.map(airports => ({
							label: airports.airportTranslated,
							value: airports.codAirport
						}));
						cur.city = cur.airports.map(airports => ({
							id: airports.codAirport,
							code: airports.codAirport
						}));
						cur.id = cur.country;
						return cur;
					});

					// loop into multicity search routes
					this.stopoverSearchRoute.forEach((searchRoute, idx) => {
						const searchRouteName =
							`${searchRoute.departure.code}-${searchRoute.arrival.code}`;

						/*
						 *	check from API response if country was included for the current search route.
						 *	if yes, add search route to the 'when' array of the current stopover country
						 */
						const stopoversPerRoute = stopoverResponse[idx][searchRouteName];
						if (stopoversPerRoute) {
							stopoversPerRoute.forEach(stopoverPerRoute => {
								const stopoverWithMatchedCountry =
									stopoversList.find(stopover => stopover.country === stopoverPerRoute.country);
								if (stopoverWithMatchedCountry) {
									const whenLabel =
										`${searchRoute.departure.location.city} - ${searchRoute.arrival.location.city}`;

									const whenValue =
										`${searchRoute.departure.code}-${searchRoute.arrival.code}`;

									if (stopoverWithMatchedCountry['when'] &&
										stopoverWithMatchedCountry['when'].length > 0) {
										stopoverWithMatchedCountry['when'].push({
											'label': whenLabel,
											'value': 'outbound' + ' ' + whenValue
										});
									} else {
										stopoverWithMatchedCountry['when'] = [
											{
												'label': whenLabel,
												'value': 'outbound' + ' ' + whenValue
											}
										];
									}
								}
							});
						}
					});

					this.stopovers.next(stopoversList);
				}

				this.isEligibleRoute = true;
				this.createForm(uniqueStopovers);
			} else {
				this.isEligibleRoute = false;
			}

			this.isLoading = false;

		}, error => {
			this.isEligibleRoute = false;
			this.isLoading = false;
		});
	}

	/**
	 * Create a list of unique stopovers based on the API response for all of the routes
	 */
	private createUniqueStopoverList(param) {

		const uniqueStopoverRoutes = [];
		this.stopoverSearchRoute.forEach((searchRoute, idx) => {

			if (searchRoute.departure && searchRoute.arrival) {
				const searchRouteName =
					`${searchRoute.departure.code}-${searchRoute.arrival.code}`;

				const stopoversPerRoute = param[idx][searchRouteName];
				if (stopoversPerRoute) {
					stopoversPerRoute.forEach(stopover => {
						// check if the current stopover country is already on the existing list
						const matchedList = uniqueStopoverRoutes.filter(routes => routes.country === stopover.country);
						if (matchedList.length === 0) {
							uniqueStopoverRoutes.push(stopover);
						} else {
							/*
							 *	if the current stopover country is already on the existing list,
							 *	check if the city is already on the existing list. If no, add it.
							 */
							stopover.airports.forEach(airport => {
								matchedList.forEach(country => {
									const matchedListCountryAiport =
										country.airports.filter(countryAirport =>
											country.country === stopover.country &&
											countryAirport.codAirport === airport.codAirport
										);
									if (matchedListCountryAiport.length === 0) {
										uniqueStopoverRoutes.forEach(uniqueStopover => {
											uniqueStopover.airports.push(airport);
										});
									}
								});
							});
						}
					});
				}
			}
		});

		return uniqueStopoverRoutes;
	}

	INDRA_disabled() {
		return this.tripType == TRIP_TYPE_MULTICITY ? true : false;
	}

	INDRA_getNights() {
		let stopoverDaysLimit = this.enable10DaysStopover ? 10 : 5;
		if (this.tripType == TRIP_TYPE_ROUND_TRIP) {
			if (this.form.value.searchroute && this.form.value.searchroute[0] && this.form.value.searchroute[0].departure && this.form.value.searchroute[0].arrival) {
				const departure = (this.form.get('searchroute') as FormArray).at(0).get('departure').value;
				const arrival = (this.form.get('searchroute') as FormArray).at(0).get('arrival').value;

				const range = moment.range(moment(departure, 'DD/MM/YYYY'), moment(arrival, 'DD/MM/YYYY'));
				const days = range.diff('days');

				if (days < stopoverDaysLimit) {
					return this.nights.slice(0, days);
				}
			}
		}

		if (this.tripType == TRIP_TYPE_MULTICITY) {
			if (this.form.value.searchroute && this.form.value.searchroute[0] && this.form.value.searchroute[1] &&
				this.form.value.searchroute[0].departure && this.form.value.searchroute[1].departure) {

				const departureOne = (this.form.get('searchroute') as FormArray).at(0).get('departure').value;
				const departureTwo = (this.form.get('searchroute') as FormArray).at(1).get('departure').value;

				const range = moment.range(moment(departureOne, 'DD/MM/YYYY'), moment(departureTwo, 'DD/MM/YYYY'));
				const days = range.diff('days');

				if (days < stopoverDaysLimit) {
					return this.nights.slice(0, days);
				}
			}
		}

		return this.nights;

	}

	INDRA_changeCity(event, item, index) {
		const result = item.city.find(cur => cur.id == event.target.value) || null;
		(this.form.get('stopover') as FormArray).at(index).get('city').setValue(result);
	}

	INDRA_getCity(field) {
		if (field === '') return '';
		return field['id'];
	}

	INDRA_getId(option) {
		return option && option.id ? option.id : null;
	}

	INDRA_inputOptions(item) {
		return item.map(cur => ({ label: cur, value: cur.id }));
	}

	INDRA_showBrasil(): boolean {
		if ((!this.hasSelectedRoute || !this.isEligibleRoute)) {
			return true;
		} else if (!this.selectedStopover.portugal && !this.selectedStopover.brasil) {
			return this.availableStopover.brasil;
		} else {
			return this.selectedStopover.brasil;
		}
	}

	INDRA_showPortugal(): boolean {
		if ((!this.hasSelectedRoute || !this.isEligibleRoute)) {
			return true;
		} else if (!this.selectedStopover.portugal && !this.selectedStopover.brasil) {
			return this.availableStopover.portugal;
		} else {
			return this.selectedStopover.portugal;
		}
	}

	INDRA_showNumberOfNights() {
		const index = 0;
		if (this.tripType == TRIP_TYPE_ROUND_TRIP) {
			const departureDate =
				moment((this.form.get('searchroute') as FormArray).at(index).get('departure').value, 'DD/MM/YYYY');
			const arrivalDate =
				moment((this.form.get('searchroute') as FormArray).at(index).get('arrival').value, 'DD/MM/YYYY');
			if (departureDate && arrivalDate) {
				return true;
			}
		} else if (this.tripType == TRIP_TYPE_ONE_WAY_CODE) {
			const departureDate =
				moment((this.form.get('searchroute') as FormArray).at(index).get('departure').value, 'DD/MM/YYYY');
			if (departureDate) {
				return true;
			}
		} else if (this.tripType == TRIP_TYPE_MULTICITY) {
			return true;
		}

		return false;
	}

	INDRA_getAirportByCode(code: string) {
		let returnValue: any = null;
		if (this.airportList && this.airportList.length > 0) {
			returnValue = this.airportList[0].find(airport => airport.code == code);
		}
		return returnValue;
	}

	handleAnimationPortugal(animation) {
		this.animationPortugal = animation;
	}

	handleAnimationBrasil(animation) {
		this.animationBrasil = animation;
	}

	handleAnimationBackground(animation) {
		this.animationBackground = animation;
	}

	INDRA_bookNonAwardTrip() {
		this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
		this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
		this.INDRA_close();
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_handleIncrement(formControlName) {
		const dayCountSelected = (this.form.get('stopover') as FormArray).at(0).get(formControlName).value;

		if (dayCountSelected === this.INDRA_getNights().length) {
			this.setIncrementToDisable = 'enable10Days';
		}
	}

	INDRA_resetSelectedDayCount(event) {
		(this.form.get('stopover') as FormArray).at(0).get('days').setValue(this.stopoverDaysMin);
	}
}
